/**
 * Filename of a watchlist export: `{list name} — {yyyy-MM-dd}.{ext}` (PV18,
 * SE-8360).
 * @module features/scouting/utils/watchlistExport/exportFilename
 */

import { format } from "date-fns";

/** Formats the watchlist export can be written in. */
export type WatchlistExportFormat = "csv" | "pdf";

/**
 * Builds the export filename for the list and the day.
 * @param listName - The list's display name
 * @param exportFormat - File format, which is also the extension
 * @param now - The export moment (injected for tests)
 * @returns The filename. A path separator in the list name becomes a hyphen
 * so the browser never splits the name into folders.
 */
export const exportFilename = (
  listName: string,
  exportFormat: WatchlistExportFormat,
  now: Date = new Date()
): string => {
  const safeName = listName
    .split(/[/\\]/)
    .map(part => part.trim())
    .join(" - ");
  return `${safeName} — ${format(now, "yyyy-MM-dd")}.${exportFormat}`;
};
